import { roll_rooms } from './roll_rooms';
//import wheel from './wheel';
//import settings from './settings';

export const modules = {
	roll_rooms,
};
